import React, {useEffect, useState} from 'react';
import {Grid,} from "@material-ui/core";
import {
  BoughtTogether,
  DetailsSection,
  Footer,
  ImageSection,
  ProductInfoSection,
  RelatedProducts,
  TopNavBar
} from '../../components'
import './style.scss'
import HttpService from "../../services/http.service";
import axios from "axios";
import {APP_DOMAIN_PREFIX} from "../../environment";
import {withRouter} from "react-router-dom";
import Seo from "../../components/Seo";


function ProductDetail(props) {
  const product = props?.location?.state?.product
  const [activeTab, setActiveTab] = useState(0);
  const [multiImages, setMultiImages] = useState([]);
  const [related, setRelated] = useState([]);
  const [blockchain, setBlockchain] = useState(null);

  const handleChangeTab = (event, key) => {
    console.log({key})
    setActiveTab(key)
  }

  const [fullDetail, setFullDetail] = useState(false);
  useEffect(() => {
    setFullDetail(props?.location?.pathname === '/detail')
  }, [props.location])
  const onSearchClick = (item, category) => {
    props.history.push({
      pathname: '/result',
      state: {search: item, category: category}
    })
  }
  useEffect(() => {
    HttpService.post(`api/edit/getAll/${product.harvestId}`).then(res => {
      if (res && res.data) {
        setMultiImages(res.data)
      }
    })
    //blockchain/byHarvestId/2
    HttpService.post(`api/blockchain/byHarvestId/${product.harvestId}`).then(res => {
      if (res && res.data) {
        setBlockchain(res.data)
      }
    })
  }, [product.harvestId])
  useEffect(() => {
    axios.get(`${APP_DOMAIN_PREFIX}/api/marketplace/getProductByLocation/V3/productName/null/${product?.harvest}/null/null/null`).then(res => {
      if (res) {
        //console.log(res.data)
        setRelated(res.data)
        //setLoading(false)
      }
    });
  }, [product]);
  return (
    <>
      <Seo
        title={product?.harvest || 'Product'}
        description={product?.harvest ? `${product.harvest} — verified, traceable produce on AgriLive's fair marketplace.` : undefined}
        path={`/detail/${product?.harvestId || ''}`}
        image={product?.imagePath || undefined}
      />
      <TopNavBar onClick={onSearchClick}/>
      <Grid container className='product-detail-container after-navbar-container mt-60'>
        <Grid container className={' p-main  content-container pt-0'} style={{padding: fullDetail ? 0 : 10,}}>
          <Grid item lg={4} md={4} sm={4} xs={12}>
            <ImageSection fullDetail={fullDetail} multiImages={multiImages} image={product ? product.imagePath : ''}/>
          </Grid>

          <Grid item lg={8} md={8} sm={8} xs={12}>
            <ProductInfoSection product={product} {...props} fullDetail={true}/>
          </Grid>

          <DetailsSection product={product} blockchain={blockchain} activeTab={activeTab}
                          handleChangeTab={handleChangeTab}/>
          {related && <>
            <BoughtTogether data={related}/>
            <RelatedProducts data={related} history={props.history}/>
          </>
          }
          {/*<Grid item lg={12} md={12} sm={12} xs={12} className='mb-20'*/}
          {/*      style={{backgroundColor: 'transparent', paddingTop: '2%', paddingBottom: '2%',}}>*/}
          {/*  <div className=''>*/}
          {/*    /!* <MainHeading title={'What Customers Say About AgriLive'}/>*/}
          {/*    <p className='font-14 '>Arrived as expected, well packed properly protected, looks good construction and*/}
          {/*      finish. Arrived quickly and without any extra fee. </p> *!/*/}
          {/*  </div>*/}
          {/*  /!* <SwipeableTextMobileStepper/> *!/*/}
          {/*</Grid>*/}

        </Grid>
        <div className='mt-20'><Footer/></div>

      </Grid>
    </>
  );
}

export default withRouter(ProductDetail);
